<template>
  <div class="container-col"  :class="patternClass">
    <h1 class="row-fit">
      <router-link v-for="[n, [citationForm, lempos]] in citationFormLemposPairs.entries()" :key="n" :to="getLink(lempos)">
        {{ citationForm }}
      </router-link>
    </h1>
    <h2 class="row-fit">
      متواردة لفطية على شكل
      <b>{{ pattern }}</b>،
      ترددها في المتونة
      <b :title="surfaceFormsTable"> {{ arabizeNumerals(freq) }} </b>.
      <span v-if="variants.length > 0">
        ويقال أيضًا
        <span v-for="[n, v] in variants.entries()" :id="n">
          <span v-if="n>0">و</span>
          <router-link class="variant-link" :to="v.link">
            {{v.citationForm}}
          </router-link>
        </span>
        .
      </span>
      <!-- We need better ways of giving feedback!
      <span v-if="coll && coll.rating == undefined">
        (<b-link class="delete-link" @click.stop="deleteCollocation()">
          <octicon name="x"/>
          احذف هذه المتواردة الخاطئة
        </b-link>)
      </span>
      -->
    </h2>
    <div v-if="!coll" class="loader"/>
    <div v-else class="row-fill">
      <transition-group name="examples-list" tag="div" class="examples-list">
        <div v-if="coll.good_instances.length > 0" class="example-separator" key="rated-examples">
          أمثلة
        </div>
        <collocation-example v-for="e of coll.good_instances" :key="e.ref" :example="e" :coll="coll" :is-good="true"
                              class="example" @showDetails="showDetails(e)"/>
        <div class="example-separator" key="unrated-examples">
          أمثلة لم يتم تقييمها بعد
        </div>
        <collocation-example v-for="e of coll.unrated_instances" :key="e.ref" :example="e" :coll="coll" class="example"
                              :is-good="false" @showDetails="showDetails(e)"/>
      </transition-group>
    </div>
    <b-modal ref="exampleDetails" centered hide-footer title="مثل">
      <example-details :example_ref="selectedExample.ref" v-if="selectedExample"/>
    </b-modal>
  </div>
</template>

<script>

import CollocationExample from './CollocationExample.vue'
import ExampleDetails from './ExampleDetails.vue'
import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons/x'
import { PATTERN_CLASSES } from '../lib/patters'

export default {
  name: 'CollocationDetails',
  props: {
    lempos: String,
    pattern: String,
    linkToLemmaView: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return { 'selectedExample': null }
  },
  components: { CollocationExample, ExampleDetails, Octicon },
  computed: {
    noColl: function () {
      return !this.lempos || !this.pattern
    },
    coll: function () {
      if (this.noColl) {
        return null
      }
      return this.$store.getters.getCollocation(this.lempos, this.pattern)
    },
    lemposList: function () {
      return this.lempos ? this.lempos.split(' ') : []
    },
    length: function () {
      return this.lemposList.length
    },
    lemposPairs: function () {
      return this.lemposList.map(x => x.split('+'))
    },
    lemmaList: function () {
      return this.lemposPairs.map(x => x[0])
    },
    citationFormLemposPairs: function () {
      var citationForm = this.lemmaList
      if (this.coll) {
        citationForm = this.coll.citation_form
      }
      return Array.from({ length: this.length }, (_, n) => [citationForm[n], this.lemposList[n]]);
    },
    freq: function () {
      if (!this.coll) {
        return '?'
      }
      return this.coll.freq
    },
    variants: function () {
      if (!this.coll || !this.coll.morphological_variants) {
        return []
      }
      return this.coll.morphological_variants.map((v) => ({
        citationForm: v.citation_form.join(" "),
        link: {
          name: 'collocation',
          params: {
            lempos: this.$route.params.lempos,
            collLempos: v.lempos_string,
            collPattern: v.pattern
          }
        }
      }))
    },
    surfaceForms: function () {
      if (!this.coll) {
        return []
      }
      return Object.entries(this.coll.surface_forms).sort((a, b) => a[1] < b[1])
    },
    surfaceFormsTable: function () {
      return this.surfaceForms.map(x => x[0] + ' (' + x[1] + ')').join('\n')
    },
    instances: function () { return this.coll.good_instances.concat(this.coll.unrated_instances) },
    patternClass: function () {
      if (!this.pattern) {
        return null
      }
      return PATTERN_CLASSES[this.pattern]
    }
  },
  created: function () { this.fetchData() },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    getLink: function (lemmaLempos) {
      if (this.linkToLemmaView) {
        return { name: 'lemma', params: { lempos: lemmaLempos } }
      }
      return { name: 'collocation', params: { lempos: lemmaLempos, collLempos: this.lempos, collPattern: this.pattern } }
    },
    fetchData: function () {
      if (this.lempos && this.pattern) {
        this.$store.dispatch('loadCollocation', { lempos: this.lempos, pattern: this.pattern })
      }
    },
    showDetails: function (e) {
      this.selectedExample = e
      this.$refs.exampleDetails.show()
    },
    deleteCollocation: function () {
      this.$store.dispatch('rateCollocation', { lempos: this.lempos, pattern: this.pattern, isGood: false })
    }
  }
}
</script>

<style scoped>
  h1, h2 {
    margin: 0px;
    padding: 10px 20px 5px 20px;
    background-color: var(--fg-color);
  }
  h2 {
    padding: 0px 20px 10px 20px;
    font-size: 15px;
    line-height: 150%;
  }
  h1, h1 a:link, h1 a:hover, h1 a:visited, h1 a:active, h1 a:focus
  h2 a:link, h2 a:hover, h2 a:visited, h2 a:active, h2 a:focus {
      color: white
  }
  h2 {
      color: var(--bg-color);
  }
  /* examples */
  .example {
    padding: 10px 20px;
    background-color: #EEEEEE;
  }
  .example-separator {
    padding: 5px 20px;
    background-color: var(--bg-color-2) !important;
    font-size: 80%;
    font-weight: bold
  }
  .examples-list div:nth-child(odd) {
    background-color: #E0E0E0
  }
  .variant-link {
    font-weight: bold;
    color: white
  }
  .delete-link {
    font-style: italic;
    color: lightgray
  }
  /* .examples-list-move {
    transition: transform 0.5s;
  }
  .examples-list-enter-active, .examples-list-leave-active {
  transition: all 0.5s;
  }
  .examples-list-enter, .examples-list-leave-to{
    opacity: 0;
    transform: translateX(-100px);
  } */
</style>
<